import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import {
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/system";
import CustomInput from "../../../components/inputs/CustomInput";
import { calculateAge } from "../../../utils/helper";
import moment from "moment";
import { GENDER } from "../../../utils/constants";

const PatientDetails = ({ fields, setFields, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <CustomInput
          disabled={loading}
          value={fields?.name}
          onChange={(e) =>
            setFields({ ...fields, err: "", name: e.target.value })
          }
          label={"Patient Name*"}
        />

        <Grid
          container
          alignItems="center"
          justifyContent={isMobile ? "center" : "space-evenly"}
          spacing={1}
          height={isMobile ? "auto" : "53px"}
          sx={{
            width: "99.7%",
            border: "1px solid #101536",
            borderRadius: "5px",
            mt: 3.2,
            ml: 0.2,
          }}
        >
          <FormLabel sx={{ fontSize: "16px", mr: 2 }} disabled={loading}>
            Gender*
          </FormLabel>
          {!isMobile && (
            <Box
              sx={{ width: "1px", height: "28px", backgroundColor: "navy" }}
            />
          )}
          <RadioGroup
            value={fields?.gender}
            onChange={(e) =>
              setFields({
                ...fields,
                err: "",
                gender: Number(e.target.value),
              })
            }
            row
            name="row-radio-buttons-group"
          >
            {Object.keys(GENDER).map((item) => (
              <FormControlLabel
                disabled={loading}
                key={item}
                value={GENDER[item]}
                control={<Radio sx={{ color: "#A91674" }} />}
                label={
                  item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
                }
              />
            ))}
          </RadioGroup>
        </Grid>
      </Grid>

      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                format="DD/MM/YYYY"
                sx={{ width: "100%" }}
                value={fields?.dob ? moment(fields?.dob) : null}
                onChange={(val) => {
                  if (val && val.isValid()) {
                    const isoString = val.toISOString();
                    const age = calculateAge(isoString);

                    // Only accept age between 1 and 100
                    if (age > 0 && age <= 100) {
                      setFields({
                        ...fields,
                        err: "",
                        dob: isoString,
                        age: age,
                      });
                    } else {
                      setFields({
                        ...fields,
                        err: "Enter valid date",
                        dob: "",
                        age: 0,
                      });
                    }
                  } else {
                    setFields({
                      ...fields,
                      err: "Invalid date",
                      dob: "",
                      age: 0,
                    });
                  }
                }}
                label={"DOB"}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={6}>
            <CustomInput
              disabled
              value={
                calculateAge(fields?.dob) > 0 &&
                calculateAge(fields?.dob) <= 100
                  ? calculateAge(fields?.dob)
                  : fields?.age > 0 && fields?.age <= 100
                  ? fields?.age
                  : ""
              }
              label={"Age*"}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 0.1 }}>
          <Grid item xs={12} sm={6}>
            <CustomInput
              disabled={loading}
              value={fields?.state}
              onChange={(e) =>
                setFields({ ...fields, err: "", state: e.target.value })
              }
              label={"State*"}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomInput
              disabled={loading}
              value={fields?.city}
              onChange={(e) =>
                setFields({ ...fields, err: "", city: e.target.value })
              }
              label={"City*"}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <CustomInput
          multiline
          rows={2}
          disabled={loading}
          value={fields?.patient_address}
          onChange={(e) =>
            setFields({ ...fields, err: "", patient_address: e.target.value })
          }
          label={"Address*"}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomInput
          disabled={loading}
          value={fields?.patient_phone}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 10) {
              setFields({ ...fields, err: "", patient_phone: value });
            }
          }}
          inputProps={{ maxLength: 10 }}
          label={"Phone No"}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomInput
          disabled={loading}
          value={fields?.patient_guardian_no}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 10) {
              setFields({ ...fields, err: "", patient_guardian_no: value });
            }
          }}
          inputProps={{ maxLength: 10 }}
          label={"Guardian Phone No.*"}
        />
      </Grid>
    </Grid>
  );
};

export default PatientDetails;
